import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Swal from "sweetalert2";

function CheckFilterCreation({ reference, mode, showModal, signalCloseModal }) {
  const [open, setOpen] = useState(false);

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const handleCancelCreation = () => {
    setOpen(false);
    signalCloseModal(false);
  };

  const handleCreation = async () => {
    setOpen(false);
    signalCloseModal(true);
    await sleep(1000);
    routeChange();
  };

  let navigate = useNavigate();
  const routeChange = () => {
    let path = reference == 0 ? `/feed-settings/filters` : `/feed-settings/filters/${reference}`;
    path = `/feed-settings/filters`;

    let options = reference != 0 ? { state: { templateId: reference } } : {};
    navigate(path, options);
  };

  function createSweetAlert() {
    Swal.fire({
      title: `${mode == "edit" ? "Cancel Filter Update" : "Cancel Filter Creation"}`,
      html: `${
        mode == "edit"
          ? "Your are about to Cancel the Update of a Filter. If you proceed any unsaved information will be lost."
          : "Your are about to Cancel the Creation of a new Filter. If you proceed any unsaved information will be lost."
      }`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Procced",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleCreation(result, reference);
      } else {
        handleCancelCreation();
      }
    });
  }

  useEffect(() => {
    //console.log("modal reference", reference);
  }, [reference]);

  useEffect(() => {
    setOpen(showModal);
    if (showModal) createSweetAlert();
  }, [showModal]);

  return <div></div>;
}

// Setting default values for the props of CreateTemplate
CheckFilterCreation.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreateTemplate
CheckFilterCreation.propTypes = {
  reference: PropTypes.string,
  mode: PropTypes.string,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
};

export default CheckFilterCreation;
